import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import { formatAsCurrencyOrZero } from '../../../utils/priceTools'
import SummarySectionHeader from './SummarySectionHeader'

export interface DeliveryMethodSummaryProps {
  className?: string
  description: string
  holdUntilMonday: string
  shippingAmount: number
  showEdit?: boolean
}

const DeliveryMethodSummary: React.FC<DeliveryMethodSummaryProps> = ({
  className,
  description,
  shippingAmount,
  showEdit = false,
  holdUntilMonday,
}) => {
  const text = () => {
    const main = `${description} - ${formatAsCurrencyOrZero({ amount: shippingAmount })}`
    return holdUntilMonday === '1' ? `${main} (Hold Until Monday)` : main
  }

  return (
    <Grid className={className} container item xs={12}>
      <SummarySectionHeader title="Shipping Details" navigateTo="delivery/" showEdit={showEdit} />
      <Grid item xs={12}>
        <Typography variant="body2">{text()}</Typography>
      </Grid>
    </Grid>
  )
}

const StyledDeliveryMethodSummary = styled(DeliveryMethodSummary)(({ showEdit, theme }) => ({
  borderTop: `1px solid ${theme.colors.component.checkoutBorderLight}`,
  padding: '15px 15px 20px',
  '@media(min-width: 600px)': {
    borderRadius: showEdit ? '4px 4px 0px 0px' : '0',
    borderLeft: `1px solid ${theme.colors.component.checkoutBorderLight}`,
    borderRight: `1px solid ${theme.colors.component.checkoutBorderLight}`,
  },
}))

export default StyledDeliveryMethodSummary
